module.exports = __webpack_public_path__ + "img/videos.0a539194.svg";